import React, { Component } from "react";
import MetaTags from "../MetaTags";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import ReactHtmlParser from "react-html-parser";
import { connect } from "react-redux";
import { getBlogPost } from "../../actions/blog_actions";
import { changeLoading } from "../../actions/loader_actions";
import BottomSheet from "../BottomSheet";
import Calculator from "./Calculator";
import { newsletterSignup } from "../../util/user_api_util";
import { readCookie, createCookie } from "../../helpers/cookie_helper";
import Trustbox from "../shared/Trustbox";
import TagCloud from "./TagCloud";
// import "../../styles/css/blog.css";

class BlogPost extends Component {
  constructor(props) {
    super(props);
    this.state = { thankyou: null, email: "" };
  }
  componentDidMount() {
    let path = this.props.match.params.path;
    if (path.includes(".html")) {
      path = path.replace(".html", "");
    }
    if (path !== this.props.blogPost.url && this.props.errors.length === 0) {
      this.props.changeLoading(true);
      this.props.getBlogPost(path).then(import("../../styles/css/blog.css"));
    }
  }

  validateEmail = (email) => {
    var re =
      /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
    return re.test(String(email).toLowerCase());
  };

  render() {
    let metaTagData = {
      title: this.props.blogPost.meta_title,
      og_title: this.props.blogPost.meta_title,
      twitter_title: this.props.blogPost.meta_title,
      description: this.props.blogPost.meta_description,
      og_description: this.props.blogPost.meta_description,
      twitter_description: this.props.blogPost.meta_description,
      og_image:
        "https://s3.us-west-2.amazonaws.com/figloans-static-images/blog/posts/" +
        this.props.blogPost.meta_image +
        ".jpg",
      twitter_image:
        "https://s3.us-west-2.amazonaws.com/figloans-static-images/blog/posts/" +
        this.props.blogPost.meta_image +
        ".jpg",
      canonical_link:
        "https://www.figloans.com/blog/posts/" + this.props.blogPost.url,
    };

    let html = this.props.blogPost.html;
    let tags = this.props.blogPost.tags
      ? Object.values(this.props.blogPost.tags)
      : [];

    const replaceAnchors = (node) => {
      if (node.type === "tag" && node.name === "a") {
        node.attribs.href = node.attribs.href.replace(
          "localhost",
          "localhost:3000"
        );
        node.attribs.href = node.attribs.href.replace(
          "fig-web",
          "figfrontend-web"
        );
        node.attribs.href = node.attribs.href.replace(
          "app.figloans.com",
          "figloans.com"
        );
      }
      if (node.type === "tag" && node.name === "img") {
        let imgPath = node.attribs.src.replace("/assets/", "");
        imgPath = imgPath.replace("/images/", "");

        if (imgPath.indexOf("http") === -1) {
          let hexa = imgPath.slice(imgPath.indexOf("-"), imgPath.length - 4);
          imgPath = imgPath.replace(hexa, "");
          const src = `https://s3.us-west-2.amazonaws.com/figloans-static-images/${imgPath}`;
          this.ha = false;

          node.attribs.src = src;
        }
      }
    };
    if (this.props.blogPost.url === "calculator") {
      html = <Calculator />;
    } else if (html && tags) {
      html = injectTagCloud(html, <TagCloud tags={tags} />);
    } else if (html) {
      html = ReactHtmlParser(html, { transform: replaceAnchors });
    }
    const newsletterSignedUp = readCookie("newsletter");

    function injectTagCloud(html, tagcloud) {
      html = ReactHtmlParser(html, { transform: replaceAnchors });
      try {
        let post = html[0];
        let postBody =
          post && post.props && post.props.children
            ? post.props.children
            : null;
        postBody.splice(1, 0, tagcloud);
        return html;
      } catch (error) {
        return html;
      }
    }

    return (
      <div id="blog">
        <div className="blog">
          <div className="container">
            <MetaTags metaTagData={metaTagData} />
            <div className="panel-white">
              <div className="blog-about">
                <div className="blog-about-text">
                  <h2 className="blog-name">
                    <Link
                      to="/blog"
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      A Fig a Day, Keeps Bad Credit Away
                    </Link>{" "}
                  </h2>
                  <Trustbox size="small" />
                </div>
              </div>
            </div>
            <div className="panel-grey" id="blog-background">
              <div id="post_container">
                {this.props.errors.length > 0 ? (
                  <h3>
                    There is no Fig post at this link. Click{" "}
                    <Link to="/blog">HERE</Link> to see other Figs!
                  </h3>
                ) : (
                  html
                )}
                <div className="blog-bottom">
                  <Link to="/blog">
                    <div className="return-link button">
                      Go back for more Figs!
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        {newsletterSignedUp ? null : (
          <BottomSheet thankYou={this.state.thankYou} triggerOnScroll={true}>
            {this.state.thankYou ? (
              <div className="thank-you-text-and-img">
                <div className="fig-and-thanks">
                  <img
                    alt="lavander fig"
                    src="data:image/png;base64,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"
                  />
                  <h3>Thank you!</h3>
                </div>
                <p>
                  Learn more about <a href="/what-is-fig">Fig Loans</a>
                </p>
              </div>
            ) : (
              <div className="email-capture">
                <h3>
                  Get updates from <b className="green">Fig!</b>
                </h3>
                <input
                  type="text"
                  placeholder="Enter email"
                  onChange={(e) => {
                    this.setState({ email: e.target.value });
                  }}
                />
                <div
                  className="button"
                  onClick={() => {
                    if (this.validateEmail(this.state.email.trim())) {
                      newsletterSignup(this.state.email.trim())
                        .then((success) => {
                          this.setState({ thankYou: true });
                          setTimeout(() => {
                            createCookie("newsletter", "true");
                          }, 1000);
                        })
                        .catch((error) => {
                          alert(error.errors[0]);
                        });
                    } else {
                      alert("Please enter a valid email address.");
                    }
                  }}
                >
                  Subscribe
                </div>
                <p style={{ textAlign: "center" }}>
                  Subscribe to our newsletter to receive more personal finance
                  insights, as well as special offers on Fig Loans. See our
                  privacy policy <a href="/privacy">here</a>!
                </p>
              </div>
            )}
          </BottomSheet>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  blogPost: state.entities.blog.blogPost,
  errors: Object.values(state.errors.blog),
});

const mapDispatchToProps = (dispatch) => ({
  getBlogPost: (path) => dispatch(getBlogPost(path)),
  changeLoading: (loadingState) => dispatch(changeLoading(loadingState)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(BlogPost)
);
